<template>
    <div>
        <DefaultMenu>
            <template #title>
                Repositorio de Documentos
            </template>
     
            <b-button
                v-permission="'documentos-menu-crear'"
                class="mx-1"
                v-b-modal.createModalDocument
            >
                Crear <b-icon icon="folder-plus" font-scale="1"></b-icon>
            </b-button>
            <b-button
                v-permission="'documentos-menu-notificaciones'"
                class="mx-1"
                v-b-modal.notificacionesModalDocument
                >
                Notificaciones <b-icon icon="mailbox" font-scale="1"></b-icon>
            </b-button>
        
            <template #right>
                <b-button
                    v-permission="'documentos-reportes'"
                    class="mx-2" 
                    v-b-modal.reportModalDocument
                    title="Generar Reporte"
                    v-b-tooltip.hover.left
                >
                    <b-icon icon="file-pdf"/>
                </b-button>
                <b-button
                    v-permission="'documentos-configuracion'"
                    @click="modalShowSetting = true"
                    title="Configuración"
                    v-b-tooltip.hover.left
                >
                    <b-icon icon="gear"/>
                </b-button>
            </template>
        </DefaultMenu>
        
        <BaseModal v-model="modalShowSetting" size="lg">
            <DocumentSetting></DocumentSetting>
        </BaseModal>

        <!-- Modal -->
        <b-modal id="createModalDocument" title="Crear repositorio" class="" size="xl" centered scrollable header-bg-variant="dark"
            v-model="modalShowCrear" hide-footer>

            <template #modal-header="{ close }">
                <!-- Emulate built in modal header close button action -->
                <b-button size="sm" variant="outline-warning" @click="close()">
                    Cerrar
                </b-button>

            </template>

            <!-- cuerpo -->
            <DocumentForm></DocumentForm>

        </b-modal>

        <b-modal id="notificacionesModalDocument" title="Notificaciones automáticas de los documentos" class="" size="xl" centered scrollable header-bg-variant="dark"
            v-model="modalShowNotificaciones" hide-footer>

            <template #modal-header="{ close }">
                <!-- Emulate built in modal header close button action -->
                <b-button size="sm" variant="outline-warning" @click="close()">
                    Cerrar
                </b-button>

            </template>

            <!-- cuerpo -->
             <DocumentNotification></DocumentNotification>

        </b-modal>

        <b-modal id="reportModalDocument" title="Generar reporte" class="" size="xl" centered scrollable header-bg-variant="dark"
            v-model="modalShowReport" hide-footer>

            <template #modal-header="{ close }">
                <!-- Emulate built in modal header close button action -->
                <b-button size="sm" variant="outline-warning" @click="close()">
                    Cerrar
                </b-button>
            </template>

            <!-- cuerpo -->
            <DocumentReport></DocumentReport>

        </b-modal>
    </div>
</template>
<script>
import DefaultMenu from '@/components/shared/Default-menu.vue'
import DocumentSetting from './DocumentMenu/Document-setting.vue';
import DocumentForm from '@/components/DocumentRepository/DocumentMenu/Document-form.vue'
import DocumentNotification from '@/components/DocumentRepository/DocumentMenu/Document-notification.vue'
import DocumentReport from '@/components/DocumentRepository/Document-report.vue'
import BaseModal from '@/components/shared/Base-modal.vue';

export default {
    name: 'DocumentMenu',

    data() {
        return {
            modalShowCrear: false,
            modalShowNotificaciones: false,
            modalShowSetting: false,
            modalShowReport: false,
        }
    },

    components:{
        DefaultMenu,
        DocumentForm,
        DocumentNotification,
        DocumentSetting,
        DocumentReport,
        BaseModal,
    },

    methods: {
        openModal() {
            this.modalShow = true;
        },
        closeModal() {
            this.modalShow = false;
        }
    }
}
</script>
